export enum WalletTransactionTypeEnum {
  WalletTopUp = 1,
  Purchase = 2,
  Refund = 3,
  SubscriptionTopUp = 4,
  VoucherTopUp = 5,
}

export enum WalletTransactionStatusEnum {
  Pending = 1,
  Paid = 2,
}

export interface WalletTransactionResponseDto {
  id: string;
  amount: number;
  currencyCode: string;
  briefApplicationId?: string | null;
  type?: WalletTransactionTypeEnum | null;
  status?: WalletTransactionStatusEnum | null;
  businessAccountId?: string;
  reservedForPurchase?: boolean;
  /**
   * Which channel this reservation is for. `null` marks the primary-channel
   * reservation; a number is one cross-post. Returned by the API, previously undeclared.
   */
  socialChannel?: number | null;
  /**
   * Released reservations are soft-deleted in place rather than reversed with a
   * compensating row, and `isDeleted` is a plain column (not a TypeORM delete column),
   * so the API returns them. Anything summing reservations must filter on this.
   */
  isDeleted?: boolean;
  createdDate?: string | Date;
  paidDate?: string | Date;
}

export enum PayoutProviderEnum {
  Telleroo = 'Telleroo',
  Airwallex = 'Airwallex',
}
